// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__24hIo","location":"Header_location__3vuYs"};